export const calculateTimeAsPerTimeZone = (
  time: string | Date,
  timeZone: string,
) => {
  const str = new Date(time).toLocaleString('en-US', {
    timeZone,
  });

  return new Date(str);
};
